import { makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { SubmitDialog } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { EditPayoffAdjustmentsForm } from "./editPayoffAdjustmentsForm";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const EditPayoffAdjustmentsDialog = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <div>
      <SubmitDialog
        open={payoffCalculatorStore.isEditPayoffAdjustmentsDialogOpen}
        title="Edit Payoff Adjustments"
        maxWidth="md"
        handleOk={() => payoffCalculatorStore.savePayoffAdjustments()}
        handleClose={() => payoffCalculatorStore.setIsEditPayoffAdjustmentsDialogOpen(false)}
        body={
          <EditPayoffAdjustmentsForm />
        }
        cancelButtonText={'Cancel'}
        okButtonText={'Save'}
      />
    </div>
  );
});
